import { render, staticRenderFns } from "./ProjectDialog.vue?vue&type=template&id=e4cb4358&scoped=true&"
import script from "./ProjectDialog.vue?vue&type=script&lang=js&"
export * from "./ProjectDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDialog.vue?vue&type=style&index=0&id=e4cb4358&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4cb4358",
  null
  
)

export default component.exports